<template>
  <div class="card-3d">
    <div :class="['card ', value  ? 'card-front' : 'card-front-click']">
      <slot name="front"></slot>
    </div>
    <div :class="['card',  value  ? 'card-back' : 'card-back-click']">
      <slot name="back"></slot>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      value: {
        //正反面
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
      };
    },
    watch: {

    },
    methods: {

    },
  };
</script>
<style lang="scss">
  .card-3d {
    width: 100%;
    height: 100%;
    position: relative;
    perspective: 1500px;
    background-color: transparent;
    transform-style: preserve-3d;
    .card {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transition: 1s ease-in-out;
      backface-visibility: hidden;
      -webkit-font-smoothing: antialiased;
      &.card-front {
        transform:  rotateY(0deg);
      }
      &.card-back {
        transform: rotateY(180deg);
      }

      &.card-front-click {
        transform: rotateY(180deg);
      }
      &.card-back-click {
        transform:  rotateY(360deg);
      }
    }
  }
</style>
